/**
 * Encode val in sha 256 hash.
 * Usage: window.sha256Hash('STRINGTOHASH').then((result) => {});
 *
 * @param value
 * @returns {Promise<string>}
 */
window.sha256Hash = (value) =>
    crypto
        .subtle
        .digest('SHA-256', new TextEncoder('utf-8').encode(value))
        .then(h => {
            let hexes = [],
                view = new DataView(h);
            for (let i = 0; i < view.byteLength; i += 4) {
                hexes.push(('00000000' + view.getUint32(i).toString(16)).slice(-8));
            }
            return hexes.join('');
        });